export const state = {
  brandColor: "#1C1836",
}

export const getters = {
  brandColor: (state) => {
    return state.brandColor
  },
}
